import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Fetches the ad-network config (AdSense/AdMob) once. Safe on public pages.
export function useAdsConfig() {
  const [config, setConfig] = useState(null);
  useEffect(() => {
    let alive = true;
    api.getAdsConfig()
      .then((c) => alive && setConfig(c || {}))
      .catch(() => alive && setConfig({}));
    return () => { alive = false; };
  }, []);
  return config;
}
